module.exports = __webpack_public_path__ + "static/media/creative-agency.08b6e36b.png";